import Enumerable from 'linq';
import { MostrarMensaje } from './ManejoMensajes';
import isEmail from 'validator/lib/isEmail';
import * as moment from 'moment';

export const ValidarPropiedad = (listadoCamposRequeridos, objetoCampos, dispatch, mostrarMensajes = true) => {
    let listErrors = [];
    const keysObjeto = Object.keys(objetoCampos);

    keysObjeto.map((llave) => {
        try {
            const valorCampo = objetoCampos[llave].toString().trim();
            const requerido = Enumerable.from(listadoCamposRequeridos).any(x => x.code.toLowerCase() === llave.toLowerCase());
            if (requerido === true && (valorCampo === '' || valorCampo === '00000000-0000-0000-0000-000000000000')) {
                const codeError = Enumerable.from(listadoCamposRequeridos).first(x => x.code.toLowerCase() === llave.toLowerCase()).codeError;
                listErrors.push(codeError);
            }
        } catch (e) { }        
    });
    if (listErrors.length > 0 && mostrarMensajes) {
        MostrarMensaje(dispatch, 'warning', listErrors);
    }
    return listErrors.length === 0;
};


export const ValidarFormatoFecha = (fecha) => {
    return moment(fecha, moment.ISO_8601, true).isValid();
}

export const ValidarFormatoCorreo = (correo) => {
    return isEmail(correo);
}

export const ValidarFormatoUUID = (uuid) => {
    let s = "" + uuid;

    s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    if (s === null) {
        return false;
    }
    return true;
}